
const getters = {
  redirect: state => state.user.redirect,
  proxyFlag: state => state.user.proxyFlag,
  bankInfo: state => state.user.bankInfo,
  proxyInfo: state => state.user.proxyInfo,
}
export default getters
